import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
import { PapiDaDeviationReportInit } from '@wix/da-papi-types';

export const initialize = createAction(
  `${actionTypePrefix}/INITIALIZE`,
  (deviationId: number) => ({
    deviationId,
  })
);

export const requestSuccess = createAction(
  `${actionTypePrefix}/REQUEST_SUCCESS`,
  (deviationId: number, data: PapiDaDeviationReportInit) => ({
    deviationId,
    data,
  })
);

export const requestFailure = createAction(
  `${actionTypePrefix}/REQUEST_FAILURE`,
  (deviationId: number) => ({ deviationId })
);

export const submit = createAction(
  `${actionTypePrefix}/SUBMIT`,
  (typeid: number, deviationId: number, answers: object) => ({
    typeid,
    deviationId,
    answers,
  })
);

export const submitSuccess = createAction(
  `${actionTypePrefix}/SUBMIT_SUCCESS`,
  (deviationId: number) => ({ deviationId })
);

export const submitFailure = createAction(
  `${actionTypePrefix}/SUBMIT_FAILURE`,
  () => ({})
);
